import React, { useState } from 'react';
import classNames from 'classnames/bind';
import { useNavigate } from 'react-router-dom';
import { Form, Divider, Input, Row, Button, Space, message, Flex, Col, Select } from 'antd';

import styles from './new.module.scss';
import API from '../../helpers/API';

const cx = classNames.bind(styles);

const Page = () => {
  const navigate = useNavigate();
  const [customer, setCustomer] = useState({
    name: '',
    tel: '',
    address: '',
    addressDetail: '',
    status: 'ACTIVE',
    memo: '',
  });

  const handleChange = (e) => {
    setCustomer({
      ...customer,
      [e.target.name]: e.target.value,
    });
  };

  const validation = () => {
    if (customer.name.trim() === '') {
      message.error('고객사명을 입력해 주세요.');
      return false;
    }

    return true;
  };

  const doSave = () => {
    if (!validation()) return;

    API.post('/customers', customer).then(({ success }) => {
      if (success) {
        navigate('/customers');
      } else {
        message.error('저장을 실패했습니다.');
      }
    });
  };

  return (
    <div className={cx('container')}>
      <h1 className={cx('title')}>고객사 신규 등록</h1>
      <div className={cx('contentWrapper')}>
        <Form layout="vertical">
          <Divider orientation="left" orientationMargin={0} className={cx('divider')}>
            기본정보
          </Divider>
          <Flex vertical style={{ maxWidth: 640 }}>
            <Form.Item label="고객사명" required>
              <Input
                name="name"
                placeholder="고객사명"
                value={customer.name}
                onChange={handleChange}
                style={{ width: 300 }}
              />
            </Form.Item>
            <Form.Item label="상태" required>
              <Select
                value={customer.status}
                onChange={(value) => setCustomer({ ...customer, status: value })}
                options={[
                  { value: 'ACTIVE', label: '활성' },
                  { value: 'INACTIVE', label: '비활성' },
                ]}
                style={{ width: 300 }}
              />
            </Form.Item>
            <Form.Item label="대표 연락처">
              <Input
                name="tel"
                placeholder="대표 연락처"
                value={customer.tel}
                onChange={handleChange}
                style={{ width: 300 }}
              />
            </Form.Item>
            <Space align="center">
              <Form.Item label="주소">
                <Input
                  name="address"
                  placeholder="주소"
                  value={customer.address}
                  onChange={handleChange}
                  style={{ width: 300 }}
                />
              </Form.Item>
              <Form.Item label="상세주소">
                <Input
                  name="addressDetail"
                  placeholder="상세주소"
                  value={customer.addressDetail}
                  onChange={handleChange}
                  style={{ width: 300 }}
                />
              </Form.Item>
            </Space>
          </Flex>
          <Divider orientation="left" orientationMargin={0} className={cx('divider')}>
            부가정보
          </Divider>
          <Row style={{ maxWidth: 640 }}>
            <Col span={24}>
              <Form.Item label="메모">
                <Input.TextArea
                  name="memo"
                  value={customer.memo}
                  placeholder="메모"
                  onChange={handleChange}
                  rows={5}
                  className={cx('textArea')}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
      <Row align="middle" justify="space-between">
        <Button onClick={() => navigate(-1)}>뒤로</Button>
        <Button type="primary" onClick={doSave}>
          저장
        </Button>
      </Row>
    </div>
  );
};

export default Page;
